import React from 'react';
import '../CSS/UserProfilePage.css';

const PACKAGE_PRICE = { Basic: 'RM 29.00', Standard: 'RM 39.00', Premium: 'RM 49.00' };
const WA_NUMBER = '60134149684';

const getCardTitle = (card) => {
  return card?.greetingName || 'Draf Kad Kahwin';
};

const PaymentPopup = ({ card, onClose }) => {
  const price = PACKAGE_PRICE[card?.packageType] || 'RM 0.00';
  const cardTitle = getCardTitle(card);

  const waMessage = encodeURIComponent(
    `👋🏻 Salam Admin Sejiwa!\n\nSaya telah membuat pembayaran untuk pesanan berikut:\n\n` +
    `Nama Kad: *${cardTitle}*\n` +
    `No. Pesanan: *${card?.uniqueCode || '-'}*\n` +
    `Pakej: *${card?.packageType || '-'}*\n` +
    `Jumlah: *${price}*\n\n` +
    `Sila semak resit yang dilampirkan. Terima kasih!`
  );
  const waLink = `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${waMessage}`;
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="pay-popup-backdrop" onClick={handleBackdropClick}>
      <div className="pay-popup">
        <div className="pay-popup-header">
          <h2 className="pay-popup-title">DuitNow QR Payment</h2>
          <button className="pay-popup-close" onClick={onClose} aria-label="Tutup">&times;</button>
        </div>

        <div className="pay-popup-order-summary">
          <div className="pay-popup-order-row">
            <span className="pay-popup-order-label">Card Title</span>
            <span className="pay-popup-order-value">{cardTitle}</span>
          </div>
          <div className="pay-popup-order-row">
            <span className="pay-popup-order-label">Order No.</span>
            <span className="pay-popup-order-value mono">{card?.uniqueCode || '-'}</span>
          </div>
          <div className="pay-popup-order-row">
            <span className="pay-popup-order-label">Package</span>
            <span className="pay-popup-order-value">{card?.packageType || '-'}</span>
          </div>
          <div className="pay-popup-order-row pay-popup-order-total">
            <span className="pay-popup-order-label">Total Amount</span>
            <span className="pay-popup-order-value pay-popup-price">{price}</span>
          </div>
        </div>

        <div className="pay-popup-qr-wrapper">
          <img
            src="/QR-Payment.PNG"
            alt="DuitNow QR Code"
            className="pay-popup-qr"
          />
          <p className="pay-popup-qr-hint">Scan with any banking app</p>
        </div>

        <div className="pay-popup-steps">
          <p className="pay-popup-steps-title">How to Send Receipt</p>
          <ol className="pay-popup-steps-list">
            <li>Make payment using the QR code above</li>
            <li>Save <strong>payment receipt</strong></li>
            <li>Click the WhatsApp button below and send the receipt to us</li>
          </ol>
        </div>

        <p className="pay-popup-note">
          Admin will check and activate your card shortly after payment is received.
        </p>

        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          className="pay-popup-wa-btn"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
            <path d="M11.999 2C6.477 2 2 6.477 2 12c0 1.99.563 3.850 1.54 5.43L2.046 22l4.702-1.466A9.96 9.96 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.126-1.148l-.295-.176-3.064.956.89-3.093-.192-.315A7.96 7.96 0 014 12c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8z" />
          </svg>
          Send Receipt via WhatsApp
        </a>
      </div>
    </div>
  );
};

export default PaymentPopup;
